/* src/app/app.scss */
.emi-container {
  display: flex;
  flex-direction: row;
  max-height: calc(var(--vh, 1vh) * 100);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.emi-content {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2.285rem;
}
.lp-header {
  --header-padding: 2rem 1.5rem;
  position: fixed;
  width: 100%;
  padding: var(--header-padding, 5rem 14.5rem);
  z-index: 999;
  pointer-events: none;
  transition: padding 0.1s ease-in-out;
}
@media (min-width: 768px) {
  .lp-header {
    --header-padding: 3rem 5.5rem;
  }
}
@media (min-width: 1280px) {
  .lp-header {
    --header-padding: 4rem 14.5rem;
  }
}
.lp-header.fixed {
  padding-top: 1rem;
}
.emi-container:has(emi-paga-document) emi-side-nav,
.emi-container:has(emi-paga-document) emi-footer {
  display: none;
}
.emi-container:has(emi-paga-document) > div {
  min-width: 0;
  min-height: 0;
}
.emi-container:has(emi-paga-document) .emi-content {
  padding: 0;
  min-width: 0;
  min-height: 0;
}
@media (max-width: 760px) {
  .emi-container:has(emi-paga-review) emi-side-nav {
    display: none;
  }
  .emi-container:has(emi-paga-review) > div {
    min-width: 0;
  }
  .emi-container:has(emi-paga-review) .emi-content {
    padding: 0;
    min-width: 0;
  }
}
/*# sourceMappingURL=app-C5DVAWMW.css.map */
